import { TagsResponse } from '../../../models/tags/TagsResponse';
import { getTags } from '../../services/tags/TagsService';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { GET_TAGS_KEYS } from '../../query/tags/keys';

export const useGetTags = (projectId: number | null) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId;

  const {
    data: tags,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<TagsResponse[]>({
    queryKey: [GET_TAGS_KEYS, projectId],
    queryFn: () => getTags(projectId!),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: queryEnabled,
  });

  return {
    tags: queryEnabled ? tags ?? [] : [],
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: [GET_TAGS_KEYS, projectId],
        refetchType: 'active',
      }),
  };
};
